import { render, staticRenderFns } from "./item-details.vue?vue&type=template&id=4f821fa0&"
import script from "./item-details.vue?vue&type=script&lang=js&"
export * from "./item-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports